module.exports = __webpack_public_path__ + "img/product_k.e8fe0425.png";